var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('result-index',{attrs:{"qr_img":_vm.qr_img,"history_url":"/packageA/loan_computer/share/result/history","prepayment_calc_link":_vm.prepayment_calc_link,"redirect_url":"/packageA/loan_computer/main"}})}
var staticRenderFns = []

export { render, staticRenderFns }